import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { PropTypes } from 'mobx-react'

import { ImageHeader,ImageHeading } from '../components/OnePager/ImageSectionStyle'
import { NavSpacer, LightBackground, Black, BlackHeading } from '../components/GeneralStyle'

import headerImage from '../images/impressum_headerimage.jpg'


class Impressum extends Component {

  componentWillMount() {
    // let all components know that this is the page home
  }

  render() {

    return (
      <div>

        <Grid fluid>

          <NavSpacer />
          <LightBackground className={"fillScreen"}>
            <ImageHeader height={350} background={headerImage}>
              <ImageHeading>IMPRESSUM</ImageHeading>
            </ImageHeader>
            <Row style={{ padding: 60 }}>
          <div className={'content-wrapper'} style={{ maxWidth: 1200}}>
              <BlackHeading style={{ textAlign: "left" }}>Allgemeine Informationen</BlackHeading>
              <h5 style={{ color: "black" }}> THE LOGE GmbH </h5>
              <Black> Gesellschafter:</Black>
              <Black>Mag. Gerald Enderle, MBA</Black>
              <Black>Thomas Schnöll</Black>
              <br />
              <Black>Badeteich Hofstädter 8a</Black>
              <Black>AT-2353 Guntramsdorf</Black>
              <br />
              <Black>Tel: <a href="tel:+43 676 944 44 81">+43 676 944 44 81</a></Black>
              <Black>E-Mail: <a href="mailto:kontakt@the-loge.com">kontakt@the-loge.com</a></Black>
              <br />
              <BlackHeading style={{ textAlign: "left" }}>Offenlegung gemäß § 25 Mediengesetz</BlackHeading>
              <Black>Gegenstand des Unternehmens ist die Administration eines exklusiven Mitgliederverbandes und Förderung
                                         derer Sport- sowie Geschäftsaktivitäten.</Black>
              <br />
              <BlackHeading style={{ textAlign: "left" }}>Urheberrecht</BlackHeading>
              <Black>Sämtliche Inhalte dieser Website sind urheberrechtlich geschützt und nur für den
                                        persönlichen Gebrauch bestimmt. Alle Rechte, insbesondere das Recht der Vervielfältigung
                                        und der Verbreitung sowie der Übersetzung, sind vorbehalten. Jede den Bestimmungen des
                                        Urheberrechtsgesetzes widersprechende Nutzung von Inhalten dieser Website ohne ausdrückliche
                                        vorherige Zustimmung des Rechteinhabers ist untersagt.</Black>
              <br />

              <BlackHeading style={{ textAlign: "left" }}>Haftungsausschlüsse</BlackHeading>
              <Black>Die die auf dieser Website bereitgestellten Informationen wurden sorgfältig überprüft. Jedoch wird keine Haftung dafür übernommen, dass alle Angaben vollständig richtig sind. Die Informationen auf der Website können und sollen eine individuelle Rechtsberatung nicht ersetzen.
              Für fremde Inhalte, also insbesondere für den Inhalt fremder Beiträge und verlinkter Websites, wird ebenfalls keinerlei Haftung bzw. Verantwortung übernommen.
              </Black>
              <br />
              <BlackHeading style={{ textAlign: "left" }}>Gender-Hinweis</BlackHeading>
              <Black>
                Im Sinne einer besseren Lesbarkeit der Texte auf unserer Website haben wir entweder die männliche oder weibliche Form einer Bezeichnung gewählt. Dies impliziert keinesfalls eine Benachteiligung des jeweils anderen Geschlechts. Frauen und Männer sollen sich von den Inhalten gleichermaßen angesprochen fühlen.
              </Black>
              <br />
              <BlackHeading style={{ textAlign: "left" }}>Google Analytics</BlackHeading>
              <Black>Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“). Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren: http://tools.google.com/dlpage/gaoptout
                                          Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter den Google Analytics Bedingungen bzw. unter der Google Analytics Übersicht. Wir weisen Sie darauf hin, dass auf dieser Webseite Google Analytics um den Code „gat._anonymizeIp();“ erweitert wurde, um eine anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu gewährleisten.
</Black>
            </div>
            </Row>
          </LightBackground>
        </Grid>

      </div >
    );
  }
}

Impressum.propTypes = {
  appStore: PropTypes.observableObject
};

export default Impressum;



// WEBPACK FOOTER //
// /src/pages/Impressum.js